import { Component, ViewChild, ElementRef } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../globals';
import { OdsServices } from '../services';
import { OdsConfigActiveElementsPage } from '../ods-config/ods-config-active-elements/ods-config-active-elements';
import { OdsConfigModifyElementsPage } from '../ods-config/ods-config-modify-elements/ods-config-modify-elements';
import { ConfigurationCloseCashViewPage } from '../../configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';
import { AnalyticsServices } from '../../services/analyticsServices';

/**
 * Generated class for the OdsViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ods-view',
  templateUrl: 'ods-view.html',
})
export class OdsViewPage {

  @ViewChild('takeawayViewLink') takeawayViewLink: ElementRef;
  @ViewChild('takeawayConfigLink') takeawayConfigLink: ElementRef;
  @ViewChild('takeawayViewTab') takeawayViewTab: ElementRef;
  @ViewChild('takeawayConfigTab') takeawayConfigTab: ElementRef;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public globals: Globals,
    public odsServices: OdsServices,
    public analyticsServices: AnalyticsServices) {
  }

  async ionViewWillEnter() {
    this.globals.GAtrackView('Ods', 'Ods - List', this.globals.restaurant.email, 'View', 'List ods', 'Ods', '');
    this.odsServices.checkGirona();
    await this.odsServices.getTakeawayConfig();
    
    // Suscripción en tiempo real para sincronizar el estado de web_tk_active
    this.odsServices.subscribeToRestaurantChanges();
    
    if (this.globals.restaurant.plg_pedidos_starter == undefined || this.globals.restaurant.plg_pedidos_starter == false) {
      this.odsServices.show_alert_info_starter = true;
      this.globals.restaurant.plg_pedidos_starter = true;
      //save plg_pedidos_starter
      this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_pedidos_starter: true
      });
      //send trackingExpPedidos
      this.analyticsServices.trackingExpPedidos('starter', this.globals.tracking_exp['starter']);
      //update hubspot contact
      this.globals.updateERPNextCustomer();
      //create examples
      await this.odsServices.createExamplesPlgTakeaway();
    } else {
      this.odsServices.show_alert_info_starter = false;
    }

    // Ejecutar operaciones en paralelo para mejorar el rendimiento
    await Promise.all([
      // getCartaTakeaway ahora maneja automáticamente si debe recargar o no
      this.odsServices.getCartaTakeaway(),
      this.odsServices.getTables(),
      this.odsServices.getOrders(),
      this.odsServices.getTakeawayAnalytics(),
      this.odsServices.getCP()
    ]);

    // Listener desactivado - Sin sincronización en tiempo real
    // this.odsServices.startCartaTakeawayListener();
  }

  ionViewDidLoad() {
    if (this.odsServices.show_config_tab === true) {
      // Usar ViewChild en lugar de document.getElementById
      this.takeawayViewLink.nativeElement.classList.remove("active");
      this.takeawayViewLink.nativeElement.setAttribute("aria-expanded", "false");
      this.takeawayViewTab.nativeElement.classList.remove('active');
      
      this.takeawayConfigLink.nativeElement.classList.add("active");
      this.takeawayConfigLink.nativeElement.setAttribute("aria-expanded", "true");
      this.takeawayConfigTab.nativeElement.classList.add('active');
      
      this.odsServices.show_config_tab = false;
    }
  }

  ionViewDidLeave() {
    // Limpiar todas las suscripciones con validación
    if (this.odsServices.tablesChanges) {
      this.odsServices.tablesChanges.unsubscribe();
    }
    if (this.odsServices.ordersChanges) {
      this.odsServices.ordersChanges.unsubscribe();
    }
    if (this.odsServices.restaurantChanges) {
      this.odsServices.restaurantChanges();
    }
  }

  activePedidosOnline() {
    this.globals.restaurant.web_tk_active = !this.globals.restaurant.web_tk_active;
    this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
      web_tk_active: this.globals.restaurant.web_tk_active
    });
  }

  openActiveElements() {
    this.navCtrl.push(OdsConfigActiveElementsPage);
  }

  openModifyElements() {
    this.navCtrl.push(OdsConfigModifyElementsPage);
  }

  closeCash() {
    this.navCtrl.push(ConfigurationCloseCashViewPage);
  }

}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-view/ods-view.ts